import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserManagementService } from '../service/userManagement.service';
import { Router } from '@angular/router';
import { LoginModel } from '../model/FormsEntity/loginForm';
import { NotificationService } from '../core/core.module';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  forgotPass:LoginModel = new LoginModel();
  forgotPassword = this.fb.group({
    userName:[null,Validators.compose([
      Validators.required,Validators.pattern('^[0-9]*$'),Validators.maxLength(10),Validators.minLength(10)
    ])],
    // emailId:[null,Validators.compose(
    //   [Validators.required,Validators.email]
    // )]
  });

  constructor(
    private fb: FormBuilder,
    private userMenage :UserManagementService,
    private router: Router,
    private notification : NotificationService) {}

  onSubmit() {
    if (this.forgotPassword.invalid) {
      return;
      }
    this.userMenage.forgotPassword(this.forgotPass).subscribe(data =>{
      // console.log(data)
      sessionStorage.setItem('userId',data.status.id);
      
      if(data && data.error){
        this.notification.warn(data.error.errorMessage);
      }else if(data && data.status){
        this.notification.success(data.status.detailMessage);
        this.router.navigate(['/resetPass'])
      }
      
      
    })
  }
}
